import { IHelpImpactElement, IHelpProbabilityElement } from '../../models/front';

export abstract class IHelpDataService {
  abstract getDataHelpProbability(): IHelpProbabilityElement[];
  abstract getDataHelpImpact(): IHelpImpactElement[];
}
